import React from 'react';
import { translate } from '#packages/i18n';
import { RichText, Text, TextButton } from '@wix/wix-base-ui';
import { type CustomTemplateTextAndLinkPanelProps } from './textAndLinkPanelTypes';
import style from './textAndLinkPanel.scss';

const CustomTemplateTextAndLinkPanel: React.FC<
  CustomTemplateTextAndLinkPanelProps
> = ({
  customTemplatePanelData: {
    title,
    firstParagraph,
    secondParagraph,
    links = [],
  },
  editorAPI,
}) => (
  <div className={style.customTemplateTextAndLinkDropPanel}>
    <Text skin="secondary" enableEllipsis={false} weight="bold">
      {title}
    </Text>

    <RichText className={style.dropPanelBody}>
      <div className={style.firstParagraph}>{translate(firstParagraph)}</div>
      {secondParagraph && (
        <div className={style.secondParagraph}>
          {translate(secondParagraph)}
        </div>
      )}

      {links.length > 0 && (
        <div className={style.linksWrapper}>
          {links.map(({ titleKey, onClick, dataHook }) => (
            <React.Fragment key={titleKey}>
              <TextButton
                onClick={() => onClick(editorAPI)}
                className={style.dropPanelLink}
                dataHook={dataHook}
                size="small"
              >
                {titleKey}
              </TextButton>
            </React.Fragment>
          ))}
        </div>
      )}
    </RichText>
  </div>
);

export default CustomTemplateTextAndLinkPanel;
